import * as RadioGroup from '@radix-ui/react-radio-group';
import type { ReactElement } from 'react';
import { cn } from '../../../lib/utils.ts';

export type DraftTypeOptionProps = {
    label: string;
    value: string;
};

export function DraftTypeOption({ label, value }: DraftTypeOptionProps): ReactElement {
    return (
        <RadioGroup.Item
            value={value}
            className={cn(
                ' group flex flex-auto items-center gap-2 rounded-md border bg-white p-3 text-sm',
                'data-[state="checked"]:bg-blue-25 data-[state="checked"]:border-blue-600 data-[state="checked"]:text-neutral-950',
                'disabled:text-neutral-400 disabled:border-neutral-200 disabled:background-neutral-25 disabled:data-[state="unchecked"]:cursor-not-allowed',
            )}
        >
            <div className="aspect-square h-4 w-4 rounded-full border border-neutral-300 data-[state=checked]:border-blue-400 flex items-center justify-center group-data-[state=checked]:border-blue-400">
                <div className="h-2.5 w-2.5 rounded-full bg-blue-400 group-data-[state='unchecked']:hidden" />
            </div>
            {label}
        </RadioGroup.Item>
    );
}
